import {AbstractControl, ValidatorFn} from '@angular/forms';

import {AddressValidatorKey} from './custom-validator-keys';

export function AddressValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value;

        if (!controlValue) {
            return null;
        }

        return !/^[a-zA-Z0-9\s`~!@#$%^&*()-=_+\[\]{};'\\:"|<>?,./]*$/.test(controlValue) ? { [AddressValidatorKey]: true } : null;
    };
}
